export default __webpack_public_path__ + "static/media/2042.537a55fa.png";